import { create } from 'zustand';

interface TourStore {
  currentPathname: string | null;
  setCurrentPathname: (currentPathname: string | null) => void;
  showTour: boolean;
  setShowTour: (showTour: boolean) => void;
}

export const useTourStore = create<TourStore>()((set) => ({
  currentPathname: null,
  setCurrentPathname: (currentPathname: string | null) => set({ currentPathname }),
  showTour: false,
  setShowTour: (showTour: boolean) =>
    set({
      showTour,
    }),
}));
